import React from 'react';
import { NavLink } from 'react-router-dom';

import aquavitalLogo from '../../../assets/images/logo.png';
import css from './Logo.module.css';

const Logo = () => (
    <div className={css.Logo}>
        <NavLink 
            to="/"
            exact>
            <img src={aquavitalLogo} alt="AquavitalLogo" />
        </NavLink>
    </div>
);

export default Logo;